import type { CSSProperties } from "react";

/**
 * Shared layout chrome dimensions and breakpoint conventions.
 *
 * - `md` (768px): chat sidebars, AI Agent panel overlays
 * - `lg` (1024px): app shell sidebar vs mobile nav strip / drawer
 */
export const APP_HEADER_HEIGHT_PX = 68;
export const APP_MOBILE_NAV_HEIGHT_PX = 40;
export const APP_TRUST_BAR_HEIGHT_PX = 56;

export const CHAT_MOBILE_BREAKPOINT_PX = 768;
export const APP_SHELL_DESKTOP_BREAKPOINT_PX = 1024;
/** Side-by-side chat + panel layout needs at least this host width (px). */
export const PANEL_INLINE_MIN_PX = 640;

export const appChromeCssVars = {
  "--app-header-height": `${APP_HEADER_HEIGHT_PX}px`,
  "--app-mobile-nav-height": `${APP_MOBILE_NAV_HEIGHT_PX}px`,
  "--app-trust-bar-height": `${APP_TRUST_BAR_HEIGHT_PX}px`,
  "--app-content-height":
    `calc(var(--app-viewport-height) - ${APP_HEADER_HEIGHT_PX}px - var(--app-mobile-nav-height, 0px) - var(--app-trust-bar-height, 0px))`,
} as CSSProperties;
